import { render, staticRenderFns } from "./lazy.vue?vue&type=template&id=76dcc788&scoped=true&"
import script from "./lazy.vue?vue&type=script&lang=js&"
export * from "./lazy.vue?vue&type=script&lang=js&"
import style0 from "./lazy.vue?vue&type=style&index=0&id=76dcc788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dcc788",
  null
  
)

export default component.exports